<template>
  <div>
    <section class="bg-light-gray-400 flex items-center justify-center p-4">
      <label class="text-primary-500 text-lg">感謝您參與此次的訂購</label>
    </section>
    <div class="mb-16 mt-6 sm:mb-6 sm:mt-3 sm:px-4 sm:w-full w-[896px] weiby-container">
      <div class="flex items-center justify-between mb-4">
        <p class="mb-0 text-black text-sm">
          {{ $breakpoints.sm ? '請留存此頁面以便核對訂單內容。' : '訪客模式關閉網頁後將無法登入查看，請留存此頁面以便核對訂單內容。' }}
        </p>
        <w-button
          class="flex-shrink-0 print-hidden text-sm"
          variant="outline"
          @click="onClickPrint"
        >
          {{ $breakpoints.sm ? '下載' : '下載此頁' }}
        </w-button>
      </div>
      <div class="box-shadow flex flex-col justify-between w-full">
        <div class="pt-4 px-6 rounded-t sm:pt-0 sm:px-0">
          <section class="flex sm:flex-col w-full">
            <div class="sm:bg-light-yellow sm:px-6 sm:py-2 sm:w-full w-1/2">
              <h2 class="mb-1 sm:text-sm text-black">
                {{ infos.name }}
              </h2>
              <h1 class="font-medium sm:text-lg text-primary-500 text-2xl title">
                {{ infos.store_name }}
              </h1>
            </div>
            <div class="
              flex
              justify-between
              sm:flex-col
              sm:pb-3
              sm:pt-2
              sm:px-6
              sm:w-full
              w-1/2
            ">
              <div
                class="
                  border-secondary-100
                  border-l-2
                  flex
                  flex-col
                  px-4
                  sm:border-l-0
                  sm:px-0
                  sm:justify-between
                  sm:flex-row
                "
              >
                <div class="flex items-center mb-1 sm:mb-0 text-gray-500">
                  <i v-if="!$breakpoints.sm" class="icon-small-calendar mr-1" />
                  <label class="text-sm">
                    預計領取時段
                  </label>
                </div>
                <displayed-time-format
                  :horizon="$breakpoints.sm"
                  :period="infos.period || {}"
                  text-size-class="text-base"
                />
              </div>
              <div class="flex flex-col flex-shrink-0 sm:flex-row sm:justify-between sm:mt-3">
                <div class="flex items-center mb-1 text-gray-500">
                  <i v-if="!$breakpoints.sm" class="icon-price mr-1" />
                  <span class="text-sm">訂單金額</span>
                </div>
                <span class="sm:text-lg text-right">
                  {{ infos.total | commaFormat | priceFormat }}
                </span>
              </div>
            </div>
          </section>
          <div
            v-if="$breakpoints.sm"
            class="border-b border-secondary-100 mx-6"
          />
          <section class="mt-8 sm:box-content sm:my-3 sm:px-6">
            <div
              v-if="!$breakpoints.sm"
              class="flex items-center justify-between mb-2 text-gray-500 text-sm"
            >
              <label>品項</label>
              <label>小計</label>
            </div>
            <div
              v-for="(item, itemIndex) in items"
              :key="`order-item-${itemIndex}-${item.uuid}`"
              class="flex justify-between last:mb-0 mb-4 text-sm"
            >
              <div class="flex mr-1 sm:max-w-21.25">
                <span class="flex-shrink-0 font-medium mr-1">{{ item.count }}x</span>
                <section class="flex flex-col flex-shrink flex-wrap">
                  <span :title="item.name" class="line-clamp-1">{{ item.name }}</span>
                  <span v-if="item.note" :title="item.note" class="text-gray-500">
                    {{ item.note }}
                  </span>
                </section>
              </div>
              <span class="flex-shrink-0">
                {{ item.price | commaFormat | priceFormat }}
              </span>
            </div>
          </section>
          <div
            v-if="$breakpoints.sm"
            class="border-b border-secondary-100 mx-6"
          />
          <section class="flex flex-col mt-10 sm:mt-3 sm:px-6">
            <div v-if="infos.note" class="flex items-center mb-2 sm:justify-between text-sm">
              <label class="mr-6 text-gray-500">訂購須知</label>
              <span class="text-black" v-html="infos.note" />
            </div>
            <div class="flex items-center mb-2 sm:justify-between text-sm">
              <label class="mr-6 text-gray-500">訂購姓名</label>
              <span class="text-black">
                {{ infos.purchaser }}
              </span>
            </div>
            <div class="flex items-center mb-2 sm:justify-between text-sm">
              <label class="mr-6 text-gray-500">訂購時間</label>
              <section class="text-black">
                <span class="mr-4">
                  {{ getTimeData(infos.created_at).dateString }}
                </span>
                <span>
                  {{ getTimeData(infos.created_at).timeString }}
                </span>
              </section>
            </div>
          </section>
        </div>
      </div>
      <p class="my-2 text-black text-sm">
        若訂購品項有新增或任何異動需求，請洽微碧愛普科技有限公司。
      </p>
    </div>
    <div class="order-completed__intro">
      <section
        class="
          flex
          flex-col
          items-center
          justify-center
          mb-4
          print-hidden
          sm:text-sm
          text-primary-500
        "
      >
        <span>公司團購不必每次都重新來過，</span>
        <span>資料建立後即可重複使用。</span>
      </section>
      <a
        alt="Go to official page"
        href="https://www.takeorder.tw"
        class="bg-primary-500 print-hidden px-4 py-3 rounded sm:text-sm text-white w-fit"
        target="_blank"
      >
        建立專屬你的好彙訂團購
      </a>
    </div>
  </div>
</template>

<script>
import OrderCompleted from './OrderCompleted';

export default OrderCompleted;
</script>

<style lang="scss" scoped>
@import 'OrderCompleted';
</style>
